import { underwritingApi, underwritingResultsKeys } from '@client/api/waterlily';
import { useQuery } from '@tanstack/react-query';

/**
 * Hook to fetch cached underwriting eligibility results for a client.
 *
 * Returns a map of productName to eligibility status that can be used
 * to display underwriting badges on quote cards.
 *
 * @param clientId - The client ID to fetch underwriting results for
 * @returns React Query result with underwriting data
 */
export function useUnderwritingResults(clientId: string | undefined) {
  return useQuery({
    queryKey: underwritingResultsKeys.detail(clientId ?? ''),
    queryFn: () => underwritingApi.getResults(clientId!),
    enabled: Boolean(clientId),
    // Underwriting results don't change often - cache for 5 minutes
    staleTime: 5 * 60 * 1000,
  });
}
